import React from 'react';
import Modal from '../../Modal';
import Spinner from '../../Spinner';
import GraphView from '../../GraphView';
import { observation as api } from '../../../actions/api';
import moment from 'moment';
import { getDisplayDate } from '../../../libs/date';
import Button from '../../Form/Button';
import Form, { FormActions, FormBody } from '../../Form';

class Graph extends React.Component {
  slug = 'tools/interpolation'

  state = {
    isLoading: false,
    data: [],
  }

  componentWillMount() {
    const { item: { series_id, time, value, corrected_value, status }, parameter } = this.props;

    const diff = !parameter || !parameter.interval ? 1440 : +parameter.interval * 5
    this.setState({ isLoading: true });
    const filters = {
      series_id: series_id,
      date_from: moment.utc(time).subtract(diff, 'minutes').format('YYYY-MM-DDTHH:mm:ss'),
      date_to: moment.utc(time).add(diff, 'minutes').format('YYYY-MM-DDTHH:mm:ss'),
    };
    api.fetchIndex(filters)
      .then(res => {
        if (!!res) this.setState({
          data: res.map((o) => ([getDisplayDate(o.time, { returnMills: true }), time === o.time ? null : o.value])),
        });
      })
      .catch(console.error)
      .finally(() => this.setState({ isLoading: false }));
  }

  render() {
    const { isLoading, data, } = this.state;
    const { onClose, item, parameter } = this.props;
    const options = {
      chart: {
        type: 'line',
        zoomType: 'x',
      },
      title: {
        text: '',
      },
      xAxis: {
        type: 'datetime',
        dateTimeLabelFormats: {
          second: '%H:%M:%S',
          minute: '%H:%M',
          hour: '%H:%M',
          day: '%Y-%m-%d',
          month: '%Y-%m',
          year: '%Y'
        },
      },
      yAxis: {
        title: {
          text: parameter.parameter_unit_symbol,
        },
      },
      tooltip: {
        crosshairs: true,
        shared: true,
      },
      series: [{
        name: parameter.name,
        data: data.sort((a, b) => a[0] - b[0]),
      }, {
        name: 'Original',
        data: [[getDisplayDate(item.time, { returnMills: true }), item.value]]
      }, {
        name: 'Corrected',
        data: [[getDisplayDate(item.time, { returnMills: true }), item.corrected_value]]
      }],
    };

    return (
      <Modal title='Review Interpolation' slug={this.slug} closeModal={onClose}>
        <Form>
          <FormBody>
            {isLoading && <Spinner />}
            {!!data.length && <div style={{ width: '60vw' }}><GraphView options={options} /></div>}
          </FormBody>
          <FormActions>
            <Button label='Revert' onClick={(e) => { e.preventDefault(); }} />
            <Button label='OK' onClick={onClose} />
          </FormActions>
        </Form>
      </Modal>
    );
  }
}

export default Graph;


// WEBPACK FOOTER //
// ./src/components/Tools/Interpolation/Graph.js